import script from "./VideoCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCapture.vue?vue&type=script&setup=true&lang=js"

import "./VideoCapture.vue?vue&type=style&index=0&id=5d5498ef&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5498ef"]])

export default __exports__